import { styled } from "@mui/material/styles";
import { TableContainer as MuiTableContainer } from "@mui/material";
import styledComponents from "styled-components";

export const TableContainer = styled(MuiTableContainer)(({ theme }) => ({
    overflow: 'auto',
    maxHeight: 300,
}));

const Div = styledComponents.span``;

export const ColoredIcon = styled(Div)((props) => ({
    display: 'inline-block',
    width: '10px',
    height: '20px',
    marginRight: '5px',
    backgroundColor: props.color,
}));